import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Box, Stack, Typography } from '@mui/material';

import { AccordionButton } from 'components/Button';
import { BreadCrumbs } from 'components/Breadcrumbs';
import { ContentLayout } from 'components/Layout';

import { paths } from 'routes';

import { useGetByID } from '../api/getById';
import { useTrackVisit } from 'hook/useTrackVisit';
import { DetailViewTabList } from 'components/TabList';
import { DetailsTab } from '../components/DetailsTab';
import { EditForm } from '../components/EditForm';
import { StatusToggleButton } from '../components/StatusToggleButton';
import { useAuth } from 'lib/auth';
import { QnaTab, useQnaTab } from 'features/qna';
import { PremiumBanner } from '../../subscriptions/components/PremiumBanner';
import { Loader } from 'components/Loader';

export const DetailsView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const currentTab = queryParams.get('tab') || 'details';
  const [ tab, setTab ] = useState(currentTab);  
  const [ loading, setLoading ] = useState(false);
  const [timer, setTimer] = useState(null);

  const { account, user } = useAuth();
  let { id } = useParams();
  const qnaTab = useQnaTab('job_ads', id);

  const { data: jobAd, refetch: refetchAd, error, isError, isLoading: jobAdLoading, isFetched: jobAdFetched } = useGetByID(id);   
  useTrackVisit('job_ad', jobAd?.ad_id, 'app');
  
  const switchTab = (_, newTab) => {
    navigate(`?tab=${newTab}`, { replace: true });
  };

  const isLoading = jobAdLoading;
  const isFetched = jobAdFetched;
  useEffect(() => {  
    if (isLoading) {
      const timeoutId = setTimeout(() => setLoading(true), 500);
      setTimer(timeoutId);
    } else {
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [isLoading]);

  if (isFetched) {    
    if (loading) {      
      setTimeout(() => setLoading(false), 1000);
    }
  }

  useEffect(() => {
      setTab(currentTab);
    }, [currentTab]);

  if (!loading && isError && error.message === "Object doesn't exist") {
    return <div>{error?.message}</div>;
  }

  return (
    <ContentLayout>
      {isLoading && !loading ? (
        <></>
      )
      : (
        loading ? (
          <Loader style={{marginTop: "40vh"}}/>
        )
        : (
          !loading && isError ? (
            <PremiumBanner sx={{my: 0}} message={`This DPS is only available for Premium members. Click here for more information`} handleSuccess={refetchAd} currentLevel={user.Company.subscription_level} />
          ) : (
            <Stack height="100%">
              <BreadCrumbs
                items={[
                  { name: '', to: paths.jobAd },
                  { name: 'My Ads', to: paths.myJobAds },
                  { name: jobAd?.headline ?? 'Details View' },
                ]}
              />
              <DetailViewTabList
                value={tab}
                onChange={switchTab}
                tabs={[
                  { label: 'Details' },
                  qnaTab,
                ]}
              />
              <Stack
                px={4}
                py={2}
                bgcolor="background.paper"
                borderTop="1px solid"
                borderColor="border.main"
                gap={1}
                height="100%"
              >
                {error && (
                  <PremiumBanner message={`This Job Ad is only available for Premium members. Click here for more information`} handleSuccess={refetchAd} currentLevel={user.Company.subscription_level} />
                )}
                {!error && (
                  <>
                    <DetailsTab currentTab={tab} jobAd={jobAd} />
                    <QnaTab currentTab={tab} resource="job_ads" id={id} />
                    {/* <FilesTab currentTab={tab} boosted={jobAd?.promoted} /> */}
                  </>
                )}
              </Stack>
            </Stack>
          )
        )
      )}
    </ContentLayout>
  );
};
